exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-content-center {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.negocio-dif-valor {\n  max-width: 45%;\n  padding: 0 15px 15px 15px; }\n\n.negocio-dif-icon {\n  max-width: 10%;\n  padding: 0 0 15px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/history-list/history-list.component.scss
// module id = ../../../../../src/app/components/common/history-list/history-list.component.scss
// module chunks = 0